/**
 * Import the polyfills and vendor files
 */
import './polyfills';
// Must come before any other app module so errors, spans and logs from bootstrap
// itself are captured.
import './app/bootstrap/sentry';
import './vendor';
import './index.scss';

import './app/bootstrap/globals';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { setupAxios } from '@root/app/shared/http/axiosSetup';
import { analyticsService } from '@root/app/shared/new-services/analytics.service';
import { appSettings } from '@root/app/shared/config/settings';
import App from '@root/app/bootstrap/App';
import { initializeI18nLanguage } from '@root/app/config/i18next.config';
import { setupChunkRecovery } from '@root/app/bootstrap/chunkRecovery';

setupChunkRecovery();
setupAxios();
analyticsService.init(appSettings.env);
initializeI18nLanguage();

const rootEl = document.getElementById('root');
if (rootEl) {
    createRoot(rootEl).render(React.createElement(App));
}

if (module.hot) {
    module.hot.accept();
}
